import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonBase, Drawer, IconButton } from '@mui/material';

import FolderIcon from '~/assets/icons/content-qr/folder.svg?react';
import CreateQrIcon from '~/assets/icons/sidebar/create-qr.svg?react';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

type MobileCreateActionsDrawerProps = {
  onCreateQr: () => void;
  onCreateFolder: () => void;
};

export default function MobileCreateActionsDrawer({ onCreateQr, onCreateFolder }: MobileCreateActionsDrawerProps) {
  const { t } = useTranslation();

  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const styles = useStyles();

  const handleClose = () => {
    setIsOpenDrawer(false);
  };

  return (
    <>
      <ButtonBase onClick={() => setIsOpenDrawer(true)} sx={styles.openButton} disableRipple>
        <CreateQrIcon width={24} height={24} />
      </ButtonBase>
      <Drawer
        anchor="bottom"
        open={isOpenDrawer}
        onClose={handleClose}
        PaperProps={{
          sx: styles.paper,
        }}
        slotProps={{
          backdrop: {
            sx: styles.backdrop,
          },
        }}
      >
        <IconButton onClick={handleClose} sx={styles.closeIconWrapper}>
          <CloseIcon sx={styles.closeIcon} />
        </IconButton>
        <Text variant="h2.5" sx={{ textAlign: 'center', marginBottom: '24px' }}>
          {t('common:actions')}
        </Text>
        <ButtonBase onClick={onCreateQr} sx={styles.action} disableRipple>
          <CreateQrIcon width={20} height={20} />
          <Text variant="t16Medium" sx={{ color: COLORS.primary }}>
            {t('sidebar:newQr')}
          </Text>
        </ButtonBase>
        <ButtonBase onClick={onCreateFolder} sx={styles.action} disableRipple>
          <FolderIcon width={20} height={20} />
          <Text variant="t16Medium" sx={{ color: COLORS.primary }}>
            {t('builder:nameAndFolder.createFolder')}
          </Text>
        </ButtonBase>
      </Drawer>
    </>
  );
}

function useStyles() {
  return {
    openButton: css`
      padding: 8px 24px;
      background-color: ${COLORS.primary};
      border-radius: 8px;

      path,
      line {
        stroke: ${COLORS.white};
      }
    `,
    paper: css`
      padding: 16px 16px 20px 16px;
      border-radius: 20px 20px 0 0;
    `,
    backdrop: css`
      backdrop-filter: blur(4px);
      background-color: rgba(255, 255, 255, 0.3);
    `,
    closeIcon: css`
      color: ${COLORS.textMain};
    `,
    closeIconWrapper: css`
      margin-left: auto;
    `,
    action: css`
      border-radius: 20px;
      border: 1px solid ${COLORS.primary};
      padding: 4px 20px;
      height: 40px;
      gap: 10px;

      &:last-of-type {
        margin-top: 8px;
      }

      path,
      line {
        stroke: ${COLORS.primary};
      }
    `,
  };
}
